import { ImageElement } from '@kontent-ai/gatsby-components';
import { graphql } from 'gatsby';
import { StyledLogo, StyledLinkTitle, StyledLink } from './FooterCertificationLogo.styles';
import useLinkProps from '@/components/Link/hooks/useLinkProps';

const FooterCertificationLogo = ({
  footerCertificationLogoElements: elements,
}: Queries.FOOTER_CERTIFICATION_LOGOFragment) => {
  const {
    link: {
      value: { linkElements },
    },
    logo,
  } = elements;
  const { linkChildren, linkProps } = useLinkProps({
    action: linkElements.action.value,
    target: linkElements.target?.value,
  });

  // NOTE: all images are resized to 50 pixels in height.
  const logoHeight = 50;
  // NOTE: Since the height is always 50 pixels, we need to calculate the width based on the ratio of the original image.
  const logoWidth = Math.floor(
    (logo.value.width ?? logoHeight) / ((logo.value.height ?? logoHeight) / logoHeight)
  );

  return (
    <StyledLogo>
      <StyledLink {...linkProps}>
        {linkChildren}
        <StyledLinkTitle>{linkElements.text.value}</StyledLinkTitle>
        <ImageElement
          alt={logo.value.description ?? 'Footer logo'}
          height={logoHeight}
          image={{
            ...logo.value,
            height: logoHeight,
            image_id: logo.value.name,
            width: logoWidth,
          }}
          objectFit="contain"
          width={logoWidth}
        />
      </StyledLink>
    </StyledLogo>
  );
};

export default FooterCertificationLogo;

export const fragment = graphql`
  fragment FOOTER_CERTIFICATION_LOGO on kontent_item_footer_certification_logo {
    system {
      id
    }
    footerCertificationLogoElements: elements {
      logo {
        value {
          description
          height
          name
          type
          url
          width
        }
      }
      link {
        value {
          ...LINK
        }
      }
    }
  }
`;
